/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import DateFnsUtils from "@date-io/date-fns";
import {
  Grid,
  Avatar,
  Paper,
  Button,
  IconButton,
  Icon,
} from "@material-ui/core";
import { logoutUser } from "../../actions/loginActions";
import { useStateValue } from "../../context/store";
import MaterialIcon from "../../componentes/materialIcon/materialIcon";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import PermIdentityOutlinedIcon from "@material-ui/icons/PermIdentityOutlined";
import { menuDataResponse } from "../../componentes/LeftMenu/jsonMenu";
import moment from "moment";
import esLocale from "date-fns/locale/es";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import "date-fns";
import Scrollbars from "react-custom-scrollbars";
import {
  getAllNotifications,
  getAllNotificationType,
} from "../../actions/notification-actions";
import { Alert, AlertTitle } from "@material-ui/lab";
import { useStyles } from "./style";
import autoeval from "../../images/icons/Autoeval.svg"

const Index = (props) => {
  const classes = useStyles();
  const [{ token }, dispatch] = useStateValue();
  const [date, changeDate] = useState(moment().format("LT"));
  const [getNotifications, setGetNotifications] = useState([]);
  const dateNow = moment().format("DD/MM/YYYY");
  const name = JSON.parse(localStorage.getItem("state"));
  const breadCrum = JSON.parse(localStorage.getItem("breadCrum"));
  const permissions = name?.permissions;
  const notificationType = {
    birthDate: "birthday",
    contract: "contract",
    requisition: "requisition",
    maternity: "maternity",
    refund: "refund"
  };
  const [localMenu, setLocalMenu] =useState(menuDataResponse?.menus);

  const [paginadorRequest, setPaginadorRequest] = useState({
    page: 0,
    size: 100,
    order: "DESC",
    columnOrder: "notificationDate",
  });

  const [paginadorResponse, setPaginadorResponse] = useState({
    data: [],
    totalRows: 0,
    pageSize: 0,
    pageNumber: 0,
  });

  const [paginadorResponseContract, setPaginadorResponseContract] = useState({
    data: [],
    totalRows: 0,
    pageSize: 0,
    pageNumber: 0,
  });

  const [paginadorResponseRequisition, setPaginadorResponseRequisition] = useState({
      data: [],
      totalRows: 0,
      pageSize: 0,
      pageNumber: 0,
    });

  useEffect(() => {
    getNotificationBirthDate();
  }, []);

  useEffect(() => {
    getNotificationContract();
  }, []);

  useEffect(() => {
    getNotificationRequisition();
  }, []);

  useEffect(() => {
    getNotificationMaternity();
  }, []);

  useEffect(() => {
    getNotificationRefund();
  }, []);

  const getNotificationRefund = async () => {
    const response = await getAllNotifications(
      {
        employeeFullName: null,
        initRefundDate: null,
        endRefundDate: null,
        initNotificationDate: null,
        endNotificationDate: null,
        checked: false,
      },
      {
        page: paginadorRequest.page,
        size: paginadorRequest.size,
        order: paginadorRequest.order,
        columnOrder: paginadorRequest.columnOrder,
      },
      dispatch,
      notificationType.refund
    );
    if (response && (response?.status === 200 || response?.status === 201)) {
      const newData = response?.data?.refundPage;
      if (newData?.content.length > 0) {
        let respRefundDate = newData?.content;
        for (let i = 0; i < respRefundDate?.length; i++) {
          respRefundDate[i]["type"] = notificationType.refund;
        }
        setGetNotifications((current) => current.concat(respRefundDate));
      }
    }
  };

  const getNotificationMaternity = async () => {
    const response = await getAllNotifications(
      {
        employeeFullName: null,
        initMaternityDate: null,
        endMaternityDate: null,
        initNotificationDate: null,
        endNotificationDate: null,
        checked: false,
      },
      {
        page: paginadorRequest.page,
        size: paginadorRequest.size,
        order: paginadorRequest.order,
        columnOrder: paginadorRequest.columnOrder,
      },
      dispatch,
      notificationType.maternity
    );
    if (response && (response?.status === 200 || response?.status === 201)) {
      const newData = response?.data?.maternityLicenceNotificationPage;
      if (newData.content.length > 0) {
        let responseMaternityDate = newData?.content;
        for (let i = 0; i < responseMaternityDate.length; i++) {
          responseMaternityDate[i]["type"] = notificationType.maternity;
        }
        setGetNotifications((current) => current.concat(responseMaternityDate));
        setPaginadorResponse({
          data: newData?.content,
          totalRows: newData?.totalElements,
          pageSize: newData?.size,
          pageNumber: newData?.totalPage,
        });
      } else {
        setPaginadorResponse({
          data: [],
          totalRows: 0,
          pageSize: 0,
          pageNumber: 0,
        });
      }
    }
  };

  const getNotificationBirthDate = async () => {
    const response = await getAllNotifications(
      {
        employeeFullName: null,
        initBirthdayDate: null,
        endBirthdayDate: null,
        initNotificationDate: null,
        endNotificationDate: null,
        checked: false,
      },
      {
        page: paginadorRequest.page,
        size: paginadorRequest.size,
        order: paginadorRequest.order,
        columnOrder: paginadorRequest.columnOrder,
      },
      dispatch,
      notificationType.birthDate
    );
    if (response && (response?.status === 200 || response?.status === 201)) {
      const newData = response?.data?.birthdayPage;
      if (newData.content.length > 0) {
        let responseBirthDate = newData?.content;
        for (let i = 0; i < responseBirthDate.length; i++) {
          responseBirthDate[i]["type"] = notificationType.birthDate;
        }
        setGetNotifications((current) => current.concat(responseBirthDate));
        setPaginadorResponse({
          data: newData?.content,
          totalRows: newData?.totalElements,
          pageSize: newData?.size,
          pageNumber: newData?.totalPage,
        });
      } else {
        setPaginadorResponse({
          data: [],
          totalRows: 0,
          pageSize: 0,
          pageNumber: 0,
        });
      }
    }
  };

  const getNotificationContract = async () => {
    const response = await getAllNotifications(
      {
        employeeFullName: null,
        initContractDate: null,
        endContractDate: null,
        initNotificationDate: null,
        endNotificationDate: null,
        checked: false,
      },
      {
        page: paginadorRequest.page,
        size: paginadorRequest.size,
        order: paginadorRequest.order,
        columnOrder: paginadorRequest.columnOrder,
      },
      dispatch,
      notificationType.contract
    );
    if (response && (response?.status === 200 || response?.status === 201)) {
      const newData = response?.data?.contractPage;
      if (newData.content.length > 0) {
        let responseContract = newData?.content;
        for (let i = 0; i < responseContract.length; i++) {
          responseContract[i]["type"] = notificationType.contract;
        }
        setGetNotifications((current) => current.concat(responseContract));
        setPaginadorResponseContract({
          data: newData?.content,
          totalRows: newData?.totalElements,
          pageSize: newData?.size,
          pageNumber: newData?.totalPage,
        });
      } else {
        setPaginadorResponseContract({
          data: [],
          totalRows: 0,
          pageSize: 0,
          pageNumber: 0,
        });
      }
    }
  };

  const getNotificationRequisition = async () => {
    const response = await getAllNotifications(
      {
        processManagerEmail: null,
        initRequisitionDate: null,
        endRequisitionDate: null,
        initNotificationDate: null,
        endNotificationDate: null,
        checked: false,
      },
      {
        page: paginadorRequest.page,
        size: paginadorRequest.size,
        order: paginadorRequest.order,
        columnOrder: paginadorRequest.columnOrder,
      },
      dispatch,
      notificationType.requisition
    );
    if (response && (response?.status === 200 || response?.status === 201)) {
      const newData = response?.data?.requisitionsPage;
      if (newData.content.length > 0) {
        let responseRequisition = newData?.content;
        for (let i = 0; i < responseRequisition.length; i++) {
          responseRequisition[i]["type"] = notificationType.requisition;
        }
        setGetNotifications((current) => current.concat(responseRequisition));
        setPaginadorResponseRequisition({
          data: newData?.content,
          totalRows: newData?.totalElements,
          pageSize: newData?.size,
          pageNumber: newData?.totalPage,
        });
      } else {
        setPaginadorResponseRequisition({
          data: [],
          totalRows: 0,
          pageSize: 0,
          pageNumber: 0,
        });
      }
    }
  };

  useEffect(() => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Inicio",
      index: breadCrum.index !== -10 ? -1 : breadCrum?.index,
    });
    if (breadCrum?.index === -10) {
      setTimeout(() => {
        dispatch({
          type: "SET_BREADCRUMB",
          breadCrumbText: "Inicio",
          index: -1,
        });
      }, 120);
    }
  }, []);

  const handleLogoutButtonClick = (e) => {
    e.preventDefault();
    setTimeout(() => {
      logoutUser(dispatch, token?.refresh_token).then(() => {
        window.localStorage.removeItem("token_app");
        window.localStorage.removeItem("breadCrum");
        props.history.push("/auth/login");
      });
    }, 500);
  };

  const redirectPage = (indexBreadCrumb, breadCrumb, url) => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: breadCrumb,
      index: indexBreadCrumb,
    });
    props.history.push(`/dashboard${url}`);
  };

  const launchNotification = async () => {
    if (breadCrum.index === -10) {
      const response = await getAllNotificationType();
      if (response?.status === 200 || response?.status === 201) {
        const data = response?.data;
        for (let i = 0; i < data.length; i++) {
          const resp = data[i];
          if (resp.notificationType === "BIRTHDAY_NOTIFICATION" && resp?.records > 0 ){
            const icon = 'card_giftcard';
            const title = 'Cumpleaños';
            const text = 'Revise los cumpleaños de la semana';
            returnSnackbar(icon, title, dateNow, text);
          }
          if ( resp.notificationType === "CONTRACTS_NOTIFICATION" && resp?.records > 0){
            const icon = 'list_alt';
            const title = 'Contratos';
            const text = 'Revise los contratos que finalizan en un mes';
            setTimeout(() => {
              returnSnackbar(icon, title, dateNow, text);
            }, 3000);
          }
          if (resp.notificationType === "REQUISITIONS_NOTIFICATION" && resp?.records > 0 ){
            const icon = 'receipt_long';
            const title = 'Requisiciones';
            const text = 'Tiene requisiciones pendientes por revisar';
            setTimeout(() => {
              returnSnackbar(icon, title, dateNow, text);
            }, 6000);
          }
          if ( resp.notificationType === "MATERNITY_LICENSES_NOTIFICATION" && resp?.records > 0){
            const icon = 'pregnant_woman';
            const title = 'Maternidad';
            const text = 'Tiene licencias de maternidad pendientes por revisar';
            setTimeout(() => {
              returnSnackbar(icon, title, dateNow, text);
            }, 9000);
          }
          if(resp.notificationType === "REFUNDS_NOTIFICATION" && resp?.records > 0){
            const icon = 'rotate_left';
            const title = 'Recomendaciones AT';
            const text = 'Revise las recomendaciones AT que finalizan en un mes'
            setTimeout(() => {
              returnSnackbar(icon, title, dateNow, text);
            }, 12000);
          }
        }
      }
    }
  };

  const returnSnackbar = (icon, title, dateNow, text) => {
    dispatch({
      type: "SNACKBAR_MESSAGE",
      openMessageToast: {
        open: true,
        message: (
          <Alert
            icon={
              <Icon
                fill="outlined"
                style={{ color: "#4D8D9D", fontSize: 40 }}
              >
                {icon}
              </Icon>
            }
            variant="standard"
            severity="info"
            style={{
              color: "#212121",
              backgroundColor: "#EFF3FA",
              width: 400,
            }}
          >
            <AlertTitle>
              <Grid container>
                <Grid item xs={7} md={5} style={{ marginRight: 10 }}>
                  {title}
                </Grid>
                <Grid item xs={7} md={5}>
                  {dateNow}
                </Grid>
              </Grid>
            </AlertTitle>
            {text}
          </Alert>
        ),
      },
    })
  }

  useEffect(() => {
    launchNotification();
  }, []);

  const pushNotification = (notification) => {
    props.history.push(
      `/dashboard/notifications/${notification.type}/${notification.id}`
    );
  };

  return (
    <React.Fragment>
      <Grid
        container
        spacing={3}
        direction="row"
        justify="center"
        alignItems="center"
        style={{
          alignItems: "flex-end",
          justifyContent: "space-between",
          marginBottom: "-10px",
          marginTop: "-10",
        }}
      >
        <Grid elevation={3} item xs={12} sm={6} md={6} lg={6}>
          <Paper elevation={2} style={{ borderRadius: 10 }}>
            <Grid
              container
              justify="center"
              alignItems="center"
              style={{ height: "300px" }}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                style={{ fontSize: 25, marginTop: "10%", textAlign: "center" }}
              >
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <p style={{ color: "#003D51" }}>Buenos días,</p>
                  <p style={{ color: "rgb(126,189,206)", marginLeft: 10 }}>
                    {name?.infoToken?.given_name}
                  </p>
                </div>
                <br />
                <p
                  style={{ color: "#003D51", marginTop: "-35px", fontSize: 23 }}
                >
                  ¡Tenga un excelente día!
                </p>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={6}>
                <div className={classes.imageHome}></div>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={12} lg={2}>
          <div className="cusstomMuiPicker">
            <Paper
              elevation={2}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                <DatePicker
                  disableToolbar
                  variant="static"
                  style={{
                    "& > .MuiPickersStaticWrapper-staticWrapperRoot": {
                      borderRadius: "20px !important ",
                    },
                  }}
                  openTo="date"
                  type="date"
                  //style={{height: "500px"}}
                  inputFormat="DD-MMM-YYYY"
                  value={date}
                  onChange={changeDate}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  //shouldDisableDate={filterWeekends}
                  //startOfWeek = {0}
                />
              </MuiPickersUtilsProvider>
            </Paper>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={12} lg={3} className={classes.infoUser}>
          <Paper
            style={{
              position: "relative",
              margin: "auto",
              height: 255,
              borderRadius: 10,
            }}
          >
            <Avatar
              src={require(`../../images/user1.jpg`)}
              className={classes.avatar}
            />
            <div className={classes.userName}>{name?.username}</div>
            <div className={classes.user}>
              <PermIdentityOutlinedIcon />
              <span style={{ marginTop: "10%", marginLeft: "2%" }}>
                <p style={{ margin: "auto", fontSize: 12, color: "#6E6E6E" }}>
                  Mi perfil
                </p>
                <a href="/auth/validate" className={classes.settings}>
                  {" "}
                  Restablecer contraseña
                </a>
              </span>
            </div>
            <Button
              variant="contained"
              disableElevation
              className={classes.buttonCloseSession}
              onClick={handleLogoutButtonClick}
            >
              <p style={{ fontSize: 12, margin: "auto", color: "#217B98" }}>
                Cerrar sesión
              </p>
            </Button>
          </Paper>
        </Grid>
      </Grid>
      <Grid container spacing={2} direction="row" style={{ margin: "auto" }}>
        <React.Fragment>
          <Grid item xs={12} sm={6} md={6} lg={7}>
            <h1 className={classes.styleTitles}>Atajos</h1>
            <Grid container spacing={2} direction="row">
              {localMenu?.map((menu) => (
                <React.Fragment key={menu.id}>
                  {(menu?.code === "HV" ||
                    menu?.code === "VAC" ||
                    permissions?.some((x) => x?.code === menu?.code)) &&
                    !menu?.subMenus && (
                      
                      menu?.icon !== "autoeval" ?
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={3}
                        onClick={() =>
                          redirectPage(
                            menu?.index,
                            menu?.breadCrumbText,
                            menu?.url
                          )
                        }
                      >
                        <Paper
                          elevation={2}
                          className={classes.containerAtajos}
                        >
                          <IconButton className={classes.icon}>
                            <MaterialIcon fill="outlined" name={menu?.icon} />
                          </IconButton>
                          <h1 className={classes.titleAcces}>{menu?.title}</h1>
                        </Paper>
                      </Grid>
                      :
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={3}
                        onClick={() => {
                          window.open('https://g-pull-front-dot-sae-dev.appspot.com/auth/login')
                        }}
                      >
                        <Paper
                          elevation={2}
                          className={classes.containerAtajos}
                        >
                          <IconButton className={classes.icon}>
                            <img src={autoeval} alt="Autoevaluaciones" style={{ width: "45px", marginTop: "10px", marginBottom: "7px"}} />
                          </IconButton>
                          <h1 className={classes.titleAcces}>{menu?.title}</h1>
                        </Paper>
                      </Grid>
                    )}
                  {menu?.subMenus
                    ? menu?.subMenus?.map((sub) => (
                        <React.Fragment>
                          {permissions.some((x) => x.code === sub?.code) && (
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={6}
                              lg={3}
                              onClick={() =>
                                redirectPage(
                                  sub?.index,
                                  sub?.breadCrumbText,
                                  sub?.url
                                )
                              }
                            >
                              <Paper
                                elevation={2}
                                className={classes.containerAtajos}
                              >
                                <IconButton className={classes.icon}>
                                  <MaterialIcon
                                    fill="outlined"
                                    name={sub?.icon}
                                  />
                                </IconButton>
                                <h1 className={classes.titleAcces}>
                                  {sub?.title}
                                </h1>
                              </Paper>
                            </Grid>
                          )}
                        </React.Fragment>
                      ))
                    : null}
                </React.Fragment>
              ))}
            </Grid>
          </Grid>
        </React.Fragment>
        {name?.infoToken?.type === "INTERNO" ? (
          <Grid item xs={12} sm={6} md={12} lg={5}>
            <h1 className={classes.styleTitles}>Notificaciones</h1>
            <Paper
              elevation={2}
              className={
                getNotifications.length === 0 ? classes.paper2 : classes.paper
              }
            >
              <Scrollbars
                className={
                  getNotifications.length === 0
                    ? classes.scrollBars2
                    : classes.scrollBars
                }
              >
                {getNotifications.length > 0 ? (
                  getNotifications.map((notification) => {
                    const birthDate =
                      notification?.birthdayDate === null
                        ? ""
                        : moment(notification?.birthdayDate).format(
                            "DD-MM-YYYY"
                          );
                    const notificationDate =
                      notification?.notificationDate === null
                        ? ""
                        : moment(notification?.notificationDate).format("LT");
                    return (
                      <div className={classes.wrapperNotification}>
                        <span style={{ fontSize: 14 }}>
                          <Grid container>
                            <Grid item xs={1} md={1}>
                              <EmailOutlinedIcon
                                className={
                                  notification?.checked
                                    ? classes.isCheckedEmailIcon
                                    : classes.emailIcon
                                }
                              />
                            </Grid>

                            <Grid
                              item
                              xs={10}
                              md={10}
                              onClick={() => pushNotification(notification)}
                            >
                              <span
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <p className={classes.textNotificaion}>
                                  {notification?.type === notificationType.birthDate
                                    ? `${notification?.employeeFullName} esta de cumpleaños el dia ${birthDate}`
                                    : notification?.type === notificationType.contract
                                    ? `Notificación de contrato para el empleado ${notification?.employeeFullName}`
                                    : notification?.type === notificationType.requisition 
                                    ? `Se ha ${notification?.currentStatus} la REQ-${notification?.requisitionNumber}`
                                    : notification?.type === notificationType.maternity 
                                    ? `Notificación de licencia maternidad para el empleado ${notification?.employeeFullName}`
                                    : `Notificación de recomendación para el empleado ${notification?.employeeFullName}`
                                  }
                                </p>
                                <p
                                  className={classes.notificationDate}
                                >{`${notificationDate}`}</p>
                              </span>
                            </Grid>
                            <Grid item xs={1} md={1}>
                              <CloseOutlinedIcon
                                style={{ fontSize: 17, cursor: "pointer" }}
                              />
                            </Grid>
                          </Grid>
                          <hr />
                        </span>
                      </div>
                    );
                  })
                ) : (
                  <div className={classes.haventNotifications}>
                    <h2>No tienes notificaciones</h2>
                  </div>
                )}
              </Scrollbars>
            </Paper>
          </Grid>
        ) : null}
      </Grid>
    </React.Fragment>
  );
};

export default Index;
